import { ValidationResult } from "../../../../shared/validators/interface.validation";

export class ContaContabilCodigoValidator {
    static contaContabilCodigoFormat(item: any): ValidationResult {
        var code: any = item.value;

        if (code) {
            let CODIGO_REGEXP: any = /^\d{1}\.\d{1}\.\d{1}\.\d{1}\.\d{1}\.\d{2}\.\d{2}$/;

            if (!CODIGO_REGEXP.test(code)) {
                return { "incorrectCodigoFormat": true };
            }

            return null;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/shared/validators/contaContabilCodigo.validator.ts
 **/